// DataWeb © XTRA Roberto Consoli
// xtra.visual 2.3.2

export default class XtraVisualHelper {
    public static init() {
        (<any>$).fn.xtraVisual = function (options) {
            var defaults = {
                timerInterval: 5000,
                isSelectorEnabled: true,
                isTimerEnabled: true,
                isImageBackground: false,
                isSkinBackground: false,
                isSkinFullScreen: false,
                isGestureNavigation: false,
                isKeyboardNavigation: false,
                onInit: null,
                onEnter: null,
                onShow: null,
                onExit: null
            },
                timers = [];

            options = $.extend(defaults, options);

            return this.each(function () {
                var obj = $(this),
                    $visuals = $(".visuals .item", obj),
                    $selector = $(".selector", obj),
                    $selectorPrev = $(".prev", $selector),
                    $selectorNext = $(".next", $selector),
                    $selectorItems = $(".item", $selector),
                    $visualSelected,
                    $visualPrevious,
                    index = 0,
                    timer;

                if ($visuals.length < 2) {
                    options.isTimerEnabled = false;
                } else {
                    if (options.isGestureNavigation)
                        setGestureNavigation($visuals);

                    if (options.isKeyboardNavigation)
                        setKeyboardNavigation();

                    function setGestureNavigation(element) {
                        var options = {
                            prevent_default: true,
                            no_mouseevents: true
                        };

                        (<any>$(element)).hammer(options).on("swipeleft", function () {
                            moveNext();
                        });

                        (<any>$(element)).hammer(options).on("swiperight", function () {
                            movePrev();
                        });
                    }

                    function setKeyboardNavigation() {
                        $(document).on("keydown", function (e) {
                            if (e.keyCode == 37) {
                                // left
                                movePrev();
                            } else if (e.keyCode == 39) {
                                // right
                                moveNext();
                            }
                        });
                    }

                    $selectorPrev.on("click", function () {
                        removeAllTimers();
                        movePrev();
                    });

                    $selectorNext.on("click", function () {
                        removeAllTimers();
                        moveNext();
                    });

                    $selectorItems.on("click", function () {
                        removeAllTimers();
                        moveAt(this);
                    });
                }

                $visuals.css({ "position": "absolute", "z-index": 1 });
                $visuals.hide();
                setVisual();

                function movePrev() {
                    if (!$visuals.filter(":animated").length) {
                        index = index > 0 ? index - 1 : $visuals.length - 1;
                        setVisual();
                    }
                }

                function moveNext() {
                    if (!$visuals.filter(":animated").length) {
                        index = index < $visuals.length - 1 ? index + 1 : 0;
                        setVisual();
                    }
                }

                function moveAt($selectorItem) {
                    if (!$visuals.filter(":animated").length) {
                        index = $selectorItems.index($selectorItem);
                        setVisual();
                    }
                }

                function prepareVisual() {
                    var defer = $.Deferred();

                    if (options.onInit) {
                        options.onInit($visualSelected);
                    }

                    if (options.isSkinBackground) {
                        var skinUrl = $visualSelected.data("skinurl");

                        if (options.isSkinFullScreen) {
                            $(".SkinContainer").attr("src", skinUrl);
                        } else {
                            $(".SkinContainer").css("background", "url(" + skinUrl + ") center top no-repeat");
                        }
                    }

                    if ($visualPrevious) {
                        $visualPrevious.css({ "z-index": 2 });

                        $visualSelected.show();
                        if (isVideo($visualSelected)) {
                            var player = (<any>window).$f($("iframe", $visualSelected)[0]);
                            if (player) {
                                player.api("seekTo", 0);
                                player.api("play");
                            }
                        }

                        $visualPrevious.fadeOut(400, function () {
                            $visualPrevious.css({ "z-index": 1 });
                            defer.resolve();

                            if (isVideo($visualPrevious)) {
                                var player = (<any>window).$f($("iframe", $visualSelected)[0]);
                                if (player) {
                                    player.api("seekTo", 0);
                                    player.api("pause");
                                }
                            }
                        });
                    } else {
                        $visualSelected.show();
                        defer.resolve();
                    }

                    return defer.promise();
                }

                function renderVisual() {
                    prepareVisual().then(function () {
                        // Play onenter animation
                        if (options.onEnter) {
                            options.onEnter($visualSelected).then(function () {
                                if (options.isTimerEnabled && !isVideo($visualSelected)) {
                                    startTimer().then(function () {
                                        moveNext();
                                    });
                                }
                            });
                        } else {
                            if (options.isTimerEnabled && !isVideo($visualSelected)) {
                                startTimer().then(function () {
                                    moveNext();
                                });
                            }
                        }
                    });
                }

                function startTimer() {
                    removeAllTimers();

                    var defer = $.Deferred(),
                        timer = setTimeout(function () {
                            stopTimer().then(function () {
                                defer.resolve();
                            });
                        }, options.timerInterval);

                    timers.push(timer);

                    if (options.onShow) {
                        options.onShow($visualSelected);
                    }

                    return defer.promise();
                }

                function stopTimer() {
                    var defer = $.Deferred();

                    if (options.onExit) {
                        options.onExit($visualSelected).then(function () {
                            removeAllTimers();
                            defer.resolve();
                        });
                    } else {
                        clearInterval(timer);
                        defer.resolve();
                    }

                    return defer.promise();
                }

                function setVisual() {
                    var url, title, $image, $iframe;

                    if ($visuals.index($visualSelected) !== index || !$visualSelected) {
                        setSelector();

                        if ($visualSelected) {
                            $visualPrevious = $visualSelected;
                        }

                        $visualSelected = $visuals.eq(index);
                        var isVideoItem = isVideo($visualSelected);

                        if ($visualSelected.hasClass("loaded")) {
                            if (isVideoItem) {
                                var videoInfo = getVideoInfo($visualSelected.data("url")).done(function (data) { setVideo(data.video_id, false); });
                            }

                            renderVisual();
                        } else {
                            if (options.isImageBackground && !isVideoItem)
                                $visualSelected.css({ "background-image": "url(" + $visualSelected.data("url") + ")" });

                            if (isVideoItem) {
                                var videoInfo = getVideoInfo($visualSelected.data("url")).done(function (data) {
                                    var loop = $visualSelected.data("isloop") ? "1" : "0",
                                        autoplay = $visualSelected.data("isautoplay") ? "1" : "0",
                                        isMute = $visualSelected.data("ismute") ? "1" : "0";

                                    if ($visualSelected.data("isbackground") === true) {
                                        $iframe = $("<iframe src=\"https://player.vimeo.com/video/" + data.video_id + "?loop=" + loop + "&background=1&api=1&player_id=" + data.video_id + "\" id=\"" + data.video_id + "\" class=\"iframe\" frameborder=\"0\"></iframe>");
                                    } else {
                                        $iframe = $("<iframe src=\"https://player.vimeo.com/video/" + data.video_id + "?loop=" + loop + "&autoplay=" + autoplay + "&badge=0&byline=0&title=0&portrait=0&api=1&player_id=" + data.video_id + "\" id=\"" + data.video_id + "\" class=\"iframe\" frameborder=\"0\"></iframe>");
                                    }

                                    $iframe.appendTo($visualSelected).show();
                                    $visualSelected.addClass("loaded");
                                    renderVisual();
                                    setVideo(data.video_id, isMute);
                                });
                            } else {
                                url = $visualSelected.data("url");
                                title = $visualSelected.data("title");
                                $image = $("<img class=\"visual-image\" src=\"" + url + "\" alt=\"" + title + "\" style=\"display: none;\" />");
                                $image.on("load", function () {
                                    var skinUrl = $visualSelected.data("skinurl");

                                    if (options.isSkinBackground && skinUrl === "") {
                                        var $skinImage = $("<img class=\"skin-image\" src=\"" + skinUrl + "\" style=\"display: none;\" />");

                                        $skinImage.on("load", function () {
                                            if (options.isSelectorEnabled) {
                                                $selector.show();
                                            }

                                            if (!options.isImageBackground) {
                                                $image.appendTo($visualSelected).show();
                                            }

                                            $visualSelected.addClass("loaded");
                                            renderVisual();

                                            if (options.isSkinFullScreen) {
                                                $(".skin-box").attr("src", skinUrl);
                                            } else {
                                                $(".skin-box").css("background", "url(" + skinUrl + ") center top no-repeat");
                                            }
                                        });

                                    } else {
                                        if (options.isSelectorEnabled) {
                                            $selector.show();
                                        }

                                        if (!options.isImageBackground) {
                                            $image.appendTo($visualSelected).show();
                                        }

                                        $visualSelected.addClass("loaded");
                                        renderVisual();
                                    }
                                }).on("error", function () {
                                    if (options.isTimerEnabled) {
                                        startTimer();
                                    }
                                });
                            }
                        }
                    }
                }

                function setSelector() {
                    $selectorItems.removeClass("selected");
                    $selectorItems.eq(index).addClass("selected");
                    $(".button", $selectorItems).removeClass("button-selected");
                    $(".button", $selectorItems.eq(index)).addClass("button-selected");
                }

                function setVideo(id, isMute) {
                    var iframe = $("#" + id)[0];
                    if (iframe) {
                        var player = (<any>window).$f(iframe);

                        player.addEvent("ready", function () {
                            if (isMute)
                                player.api("setVolume", 0);

                            player.addEvent("play", function () {
                                removeAllTimers();
                            });

                            player.addEvent("finish", function () {
                                moveNext();
                            });
                        });
                    }
                }

                function isVideo($item) {
                    return $item.data("type") === "video";
                }

                function removeAllTimers() {
                    for (var i = 0; i < timers.length; i++) {
                        clearInterval(timers[i]);
                    }

                    timers = [];
                }

                function getVideoInfo(data) {
                    return $.ajax({
                        type: "GET",
                        url: "https://vimeo.com/api/oembed.json?url=" + data,
                    })
                }
            });
        };
    }
}